<template>
  <div class="invoice__payment_details mt-5">
    <!-- Previous Payments Information  -->
    <h5>Previous Payments Information</h5>
    <vs-table class="mt-5" :data="salePayments">
      <template slot="thead">
        <vs-th>#</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Payment Type</vs-th>
        <vs-th>Payment Note</vs-th>
        <vs-th>Payment</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>{{ i + 1 }}</vs-td>
          <vs-td>{{ formatDate(tr.payment_date) }}</vs-td>
          <vs-td>{{ tr.payment_type }}</vs-td>
          <vs-td>{{ tr.payment_note }}</vs-td>
          <vs-td>$ {{ tr.payment_amount | currencyFilter }}</vs-td>
          <vs-td></vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- End Previous Payments Information -->
  </div>
</template>

<script>
import { dateMixins } from '@/mixins/dateMixins.js'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'InvoicePaymentDetails',

  props: {
    salePayments: Array
  },

  mixins: [paymentMixins, dateMixins],

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style>
</style>